import { Skeleton, Empty } from 'antd';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params';
import { Pagination } from 'components/pagination';
import { useGetClientContacts } from 'client-app/api/client-contacts/use-get-client-contacts';
import { useGetClientOrders } from 'client-app/api/client-orders/use-get-client-orders';
import { ClientOrdersList } from 'client-app/components/client-orders/client-orders-list';
import { PAGINATION_ORDERS_LIMIT } from 'client-app/shared/constants/paginations';
import { useClientOrdersSearchStore } from 'client-app/stores/use-client-orders-search-store';
import styles from './client-orders-list.module.scss';

export const ClientOrdersListPage = () => {
  const { page, handlePageChange } = usePaginationParams({ fixLimit: PAGINATION_ORDERS_LIMIT });
  const { search } = useClientOrdersSearchStore();

  const { data: orders, isLoading: isOrdersLoading } = useGetClientOrders({
    page,
    limit: PAGINATION_ORDERS_LIMIT,
    search,
  });

  const { data: contacts, isLoading: isContactsLoading } = useGetClientContacts();

  usePageReset([search]);

  const isLoading = isOrdersLoading || isContactsLoading;
  const pageCount = orders?.pagination?.pageCount || 1;

  return (
    <div className={styles.layout}>
      <Skeleton loading={isLoading}>
        {!orders?.data?.length ? (
          <Empty />
        ) : (
          <>
            <ClientOrdersList clientOrders={orders?.data || []} contacts={contacts || []} />
            {pageCount > 1 && (
              <Pagination
                total={orders?.pagination?.total}
                page={orders?.pagination?.currentPage}
                limit={PAGINATION_ORDERS_LIMIT}
                className={styles.pagination}
                withLimitChanger={false}
                onChange={handlePageChange}
              />
            )}
          </>
        )}
      </Skeleton>
    </div>
  );
};
